import { memo } from 'react'

export const RequiredMark = memo(function RequiredMark() {
    return (
        <div className="label-required-mark app-color-red">
            (required)
        </div>
    )
})